/**
 * DREAL fine builder — Messagerie payload when a driver is caught on
 * the road with a non-blocking HSE training expired (FCO or CACES).
 *
 * 01/06/2026 — Phase 5 gameplay penalty (Claire Maréchal module).
 *
 * Used by `coreSlice.nextDay` daily roll. Returns the message payload
 * AND the side-effect parameters (fine amount, reputation hit) so the
 * caller can apply them atomically.
 */

const TRAINING_LABEL_FR = {
  fco: 'FCO (Formation Continue Obligatoire)',
  caces: 'CACES R489 / R372',
};

export function buildDrealFineMessage({ trainingKey, driverName, fineAmount, expiresOn, totalDays }) {
  const label = TRAINING_LABEL_FR[trainingKey] || trainingKey;
  const daysOverdue = Math.max(0, totalDays - expiresOn);
  return {
    senderRole: 'role-claire-marechal',
    tone: 'warning',
    subject: `Amende DREAL — ${driverName}`,
    body:
      `🚨 Contrôle routier DREAL inopiné : **${driverName}** intercepté(e) en mission avec ` +
      `sa **${label}** expirée (échéance J${expiresOn}, soit ${daysOverdue} j de retard).\n\n` +
      `**Amende administrative : ${fineAmount.toLocaleString('fr-FR')} €** débitée de la ` +
      `trésorerie. Impact réputation : -1 point (mention au registre transport).\n\n` +
      `Action prioritaire : programmer le recyclage **${trainingKey.toUpperCase()}** depuis la ` +
      `fiche RH du chauffeur. Tant que ce n'est pas fait, chaque journée de mission ` +
      `expose l'entreprise au même risque.\n\n` +
      `— Claire Maréchal, Responsable QHSE / RSE`,
  };
}

// Per-training daily probability and amount bracket. FCO has the highest
// roadside-check density (mandatory for all pro drivers) ; CACES is rolled
// less often (only matters during handling ops).
export const DREAL_FINE_CONFIG = {
  fco:   { dailyProba: 0.015, amountMin: 600,  amountMax: 1500, repHit: 1 },
  caces: { dailyProba: 0.005, amountMin: 300,  amountMax: 900,  repHit: 1 },
};

// Cooldown after a fine (in days) before the same (driver, training)
// can be charged again. Avoids spam if the player keeps the driver on
// the road without renewing.
export const DREAL_FINE_COOLDOWN_DAYS = 30;
